export default {
  path: 'audit-logs',
  component: {
    render(c) {
      return c('router-view');
    },
  },
  children: [
    {
      path: '',
      name: 'audit-logs',
      component: () =>
        import(
          /* webpackChunkName: "allStudies" */ '../views/AuditLogs/demo.vue'
        ),
    },
  ],
};
